package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initExploringRoomArchitectureComponentPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/ExploringRoomArchitectureComponent.md", FrontMatterElement.Builder { addScalar("title", "Exploring Room Architecture component"); addScalar("date", "2017-10-22"); addScalar("description", "In this article we will dive deep into Room component. In case you missed the previous articles or don’t know about architecture components then head on to my previous article…"); addScalar("originalUrl", "https://medium.com/android-news/exploring-room-architecture-component-6db807094241"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/exploring-room-architecture-component/1jbaQwcytms5RIHnoOm4-GQ.webp"); }))
}

@Page("/articles/exploring-room-architecture-component")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun ExploringRoomArchitectureComponentPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component/1jbaQwcytms5RIHnoOm4-GQ.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("SQL queries (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/photos/fPkvU7RDmCo") {
                org.jetbrains.compose.web.dom.Text("Credits")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("content") }) {
        org.jetbrains.compose.web.dom.Text("Content")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
                org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-viewmodel-architecture-component-5d60828172f9") {
                org.jetbrains.compose.web.dom.Text("Exploring ViewModel Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-livedata-architecture-component-f9375d3644ee") {
                org.jetbrains.compose.web.dom.Text("Exploring LiveData Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-architecture-component-6db807094241") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-the-extras-cf3f0259ceed") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component — The Extras")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/building-modern-apps-using-the-android-architecture-guidelines-3238fff96f14") {
                org.jetbrains.compose.web.dom.Text("Building Modern apps using the Android Architecture Guidelines")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("preface") }) {
        org.jetbrains.compose.web.dom.Text("Preface")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In this article we will ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("dive deep")
        }
        org.jetbrains.compose.web.dom.Text(" into ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/room.html") {
            org.jetbrains.compose.web.dom.Text("Room")
        }
        org.jetbrains.compose.web.dom.Text(" component. In case you missed the previous articles or don’t know about architecture components then head on to my previous article ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
            org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The code in this article is written in Kotlin. In case you don’t know Kotlin. Read ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://android.jlelse.eu/why-kotlin-ize-your-android-development-96daece20c1d") {
            org.jetbrains.compose.web.dom.Text("this series of article")
        }
        org.jetbrains.compose.web.dom.Text(" to get started.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("introduction") }) {
        org.jetbrains.compose.web.dom.Text("Introduction")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/room.html") {
            org.jetbrains.compose.web.dom.Text("Room")
        }
        org.jetbrains.compose.web.dom.Text(" is a persistence library designed to help you save your app data into the SQLite database which ships with every Android version.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Room is a robust SQL mapping library")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("features") }) {
        org.jetbrains.compose.web.dom.Text("Features")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It provides local data persistence")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Abstraction layer over existing SQLite database")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Checks SQL query at compile time")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ability to observe for changes in the database using LiveData")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Eliminates the boilerplate code")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Plays well with ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/ReactiveX/RxJava") {
                org.jetbrains.compose.web.dom.Text("RxJava")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("persistence-spectrum") }) {
        org.jetbrains.compose.web.dom.Text("Persistence Spectrum")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The spectrum shows some of the persistence libraries and where they fall in between SQL and Objects. The Room library falls in between SQL and Objects that’s because you need to write SQL.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component/1eZc25FRPa79xLHummeT1qw.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Persistence Spectrum")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("anatomy-of-room") }) {
        org.jetbrains.compose.web.dom.Text("Anatomy of Room")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component/1nPLp8XsB7e529f82XgddyA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Room Architecture Diagram")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("database") }) {
        org.jetbrains.compose.web.dom.Text("Database")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It defines the database holder")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It is main access point to the database connection")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It defines list of entities and database access objects (DAO)")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("database-access-objects-dao") }) {
        org.jetbrains.compose.web.dom.Text("Database Access Objects (DAO)")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("They are main component of Room because they are responsible for defining methods that access database")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It defines the methods for interaction with the database")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The implementation is auto-generated at compile-time")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("entity") }) {
        org.jetbrains.compose.web.dom.Text("Entity")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For each entity a database table is created")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It represents a class which holds a database row")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("adding-it-to-your-project") }) {
        org.jetbrains.compose.web.dom.Text("Adding it to your project")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Add the following dependencies in your app or module build.gradle")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("compile **\"android.arch.persistence.room:runtime:1.0.0-rc1\"**\n") } }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("// Java \nannotationProcessor **\"android.arch.persistence.room:compiler:1.0.0-rc1\"**\n") } }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("// Kotlin\nkapt **\"android.arch.persistence.room:compiler:1.0.0-rc1\"**\n") } }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: Release Candidate 1 (RC1) is the latest version of Architecture Components (except Paging) at the moment of writing this article.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("let-s-code-with-room") }) {
        org.jetbrains.compose.web.dom.Text("Let’s code with Room!")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("entity-2") }) {
        org.jetbrains.compose.web.dom.Text("Entity")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Entity class is marked with @Entity annotation. It defines the structure of the column.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/03cc74614874fc03c1e7c34a259ba606/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The above entity creates a table named users with 2 columns namely id — auto-generated primary key and name.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By default,")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Table name is same as class name; you can change it using tableName property in @Entity.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A column is created for each field and same name that’s defined in the entity; you can change the column name using @ColumnInfo(name = \"ANYTHING\") annotation.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/92d904afa9dfc22a096ef87cda694aa2/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Primary Key")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It is required for every entity to have primary key. You can even have ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("composite")
        }
        org.jetbrains.compose.web.dom.Text(" primary keys:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/e62169b93692d6e52fda5e9cfbccd5f6/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Ignore column")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In order to tell Room to ignore a particular field you need to annotate it with @Ignore")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Since beta1 release, Room ignores transient fields by default unless they are annotated with @ColumnInfo, @Embedded or @Relation")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/740cd9f30e95f5c2c470d5e49a886a2a/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: The table names in SQLite are case-insensitive")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("database-access-objects-dao-2") }) {
        org.jetbrains.compose.web.dom.Text("Database Access Objects (DAO)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The DAO is the one who talks with the database to perform CRUD operations based upon functions defined in the DAO. It can be either interface or abstract class as the implementation is written by Room.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/e55cd5fc32bc070cad052ce9a6ad03c5/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I’m pretty sure it’s understandable except @Query annotation. During the Persistence spectrum we saw Room is in between SQL and Objects because it supports SQL. Well @Query is the place where you’ll ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("mostly")
        }
        org.jetbrains.compose.web.dom.Text(" need to write SQL.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The SQL query is checked at the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("compile time")
        }
        org.jetbrains.compose.web.dom.Text(" itself so if you made a typo or the query is wrong then you’ll get a compile time error. You can even query ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("multiple tables")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Observable queries")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Usually we want to change the state of UI when data in the database is updated. Room allows that by providing observable queries which will notify when the data in the database is changed/updated. It is achieved using ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/livedata.html") {
            org.jetbrains.compose.web.dom.Text("LiveData")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/a5e6d125d66019566391569917eb2bad/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room supports ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://reactivex.io/RxJava/2.x/javadoc/io/reactivex/Flowable.html") {
            org.jetbrains.compose.web.dom.Text("Flowable")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.reactive-streams.org/reactive-streams-1.0.1-javadoc/org/reactivestreams/Publisher.html") {
            org.jetbrains.compose.web.dom.Text("Publisher")
        }
        org.jetbrains.compose.web.dom.Text(" from ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/ReactiveX/RxJava") {
            org.jetbrains.compose.web.dom.Text("RxJava")
        }
        org.jetbrains.compose.web.dom.Text(":")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/65d38d1731c1f91cb5716d2738f3ed63/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Missed my previous article about LiveData or need to know more then check the article below:")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android.jlelse.eu/exploring-livedata-architecture-component-f9375d3644ee") {
            org.jetbrains.compose.web.dom.Text("Exploring LiveData Architecture component")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("database-2") }) {
        org.jetbrains.compose.web.dom.Text("Database")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The last component is database; it brings all the pieces of Room together viz; all the entities and their DAOs.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The version indicates the schema version. It needs to be incremented when the database schema is changed/altered.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/e750f010e6165ff4c5fdf5ef6f22d48d/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Getting the database instance:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/b28febbabf106e653cff63af6a099be8/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("The database instance is expensive. It is recommended to keep it in a singleton maybe by using Dagger 2")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Ideally, we need to tell Room when the database version is changed and provide a guide or steps to perform migration from old version to new version.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To find out more about how to implement database migrations and how they work under the hood, check out this post:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/google-developers/understanding-migrations-with-room-f01e04b07929") {
            org.jetbrains.compose.web.dom.Text("Understanding migrations with Room")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("relations") }) {
        org.jetbrains.compose.web.dom.Text("Relations")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Object Relationships are a bit ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("tricky")
        }
        org.jetbrains.compose.web.dom.Text(" in Room. It’s one of the thing which needs little improvement, nonetheless let’s dive into it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Unlike other object-relational mapping libraries, ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Room doesn’t allow entities directly referencing each other")
        }
        org.jetbrains.compose.web.dom.Text(" due to ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/room.html#no-object-references") {
            org.jetbrains.compose.web.dom.Text("lazy loading problem")
        }
        org.jetbrains.compose.web.dom.Text(". That said, it allows relations using ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/ForeignKey.html") {
            org.jetbrains.compose.web.dom.Text("ForeignKey")
        }
        org.jetbrains.compose.web.dom.Text(" which is ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("quite powerful")
        }
        org.jetbrains.compose.web.dom.Text(" but ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("tricky")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("nested-objects") }) {
        org.jetbrains.compose.web.dom.Text("Nested Objects")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sometimes we would want to decompose our object into sub-fields but keep them under one logical unit.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In layman terms, let’s say user is your entity object which has address which contains it’s own fields like city, and you want to store it under the same table called users because logically address belongs to a user.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Let’s look at code because we understand that better ;)")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/92d02a16c2268afbfac11afa13946c01/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/66ce0c43fa6654fdfcb7debacf8e498c/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Note: There is no @Entity on top of Address class because we don’t want to create a separate address table in the database. Moreover, as mentioned earlier Room doesn’t support nested entity.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component/1QLYuq937d2mdplIQKE_5RQ.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Schema of users table")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This is how the table will be created in the database. The fields from Address class will be automatically embedded by Room.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("foreign-key") }) {
        org.jetbrains.compose.web.dom.Text("Foreign Key")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Let’s look at same example of user and address using ForeignKey — one to one relation.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In, the user entity we mention it’s foreign key relation with the Address entity by specifying the foreign key of User to primary key of Address .")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/17199333068d85eda0c145f1c1e62ee4/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We define the same Address class only this time with @Entity annonation which needs PrimaryKey.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/1078c53e59f230411dd6f97b870d5b01/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Database schema")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The entities which we defined above will be stored in this fashion in the database.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component/1dwOifMsv67zUebNehOtNng.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("One to one relation between user and address")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now the important question arises, how do I fetch the data? We need to create an extra POJO to define what we need. This is done to tackle the lazy loading issue.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We define a new POJO to fetch user object and city name from addresses table.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/d2db0203099859314d144bd4fe317a96/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: You can define POJO to fetch other things of addresses table or all of the fields. It depends upon what you need")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Finally we need to write SQL query in the DAO.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/7c2ec3d82c0133040db76b86b9e0fc87/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And that’s how it’s done! I know it’s slightly tricky. It gets more tricky with one to many.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For more details check ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Relation.html") {
            org.jetbrains.compose.web.dom.Text("Relation")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://stackoverflow.com/questions/44667160/android-room-insert-relation-entities-using-room") {
            org.jetbrains.compose.web.dom.Text("One to Many with Room")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("testing") }) {
        org.jetbrains.compose.web.dom.Text("Testing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I’ll be writing a series of articles soon; showcasing testing for each architecture components which includes Room.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Meanwhile, if your curious and can’t wait then you can read about testing Room database from official docs.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/room.html#testing") {
            org.jetbrains.compose.web.dom.Text("Room Persistence Library | Android Developers")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("pro-tips") }) {
        org.jetbrains.compose.web.dom.Text("Pro-tips")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Use inMemoryDatabaseBuilder() while developing/prototyping or testing your application. It clears the database on closing the connection to the database.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Use fallbackToDestructiveMigrations() if you are really sure about it. The good part is you don’t need to write migrations. The bad part is data will be purged from the database every time you increment the database version.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Use ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/guide.html#connecting_viewmodel_and_the_repository") {
                org.jetbrains.compose.web.dom.Text("Repository")
            }
            org.jetbrains.compose.web.dom.Text(" pattern to sync the data between Room and Web (server).")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("conclusion") }) {
        org.jetbrains.compose.web.dom.Text("Conclusion")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I love the fact that Room is here to save us from the persistence problem and it supports reactive nature and all it’s goodies. I don’t like that we need to write the migration code that too in SQL. I wish it was ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://issuetracker.google.com/issues/67810148") {
            org.jetbrains.compose.web.dom.Text("automatic")
        }
        org.jetbrains.compose.web.dom.Text(" or semi-automatic; another thing is working with relation is tricky with Room which I think will get easier after v1.0.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lastly, I’m glad that it uses SQLite database which is available on every Android device; preventing additional size indirectly helping us build slim APKs.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Room is like Retrofit for database")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("update-what-s-next") }) {
        org.jetbrains.compose.web.dom.Text("Update: What’s next?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the next part we will look at RxJava, transactions Room and few more small things as pointed out by ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/u/9dbfe7302b47") {
            org.jetbrains.compose.web.dom.Text("Andrei")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/fedb9f91e907af2468a937c944ed32ab/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/android-news/exploring-room-architecture-component-6db807094241") {
            org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component")
        }
        org.jetbrains.compose.web.dom.Text(" was originally published in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/android-news") {
            org.jetbrains.compose.web.dom.Text("AndroidPub")
        }
        org.jetbrains.compose.web.dom.Text(" on Medium, where people are continuing the conversation by highlighting and responding to this story.")
    }
}
